// Useful incase of form generation
export const getObjFromArray =(data,name)=>{
    return data.find(item=>item.name===name)
}